<template>
  <div class="bg-white flex mdmax:flex-col">
    <div class="p-6 flex-1 shadow-border-r mdmax:shadow-border-b">
      <p class="font-bold text-lg mb-6">Info User</p>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
        <p class="text-neutral-500">{{ adminDetail.id }}</p>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama</label>
        <p class="text-neutral-500">{{ adminDetail.name }}</p>
      </div>
      <div class="flex items-start gap-6 mb-6">
        <div class="w-56 mdmax:flex-1 mdmax:w-auto">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Email</label>
          <p class="text-neutral-500">{{ adminDetail.email }}</p>
        </div>
        <div class="">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Username</label>
          <p class="text-neutral-500">{{ adminDetail.username }}</p>
        </div>
      </div>
      <div class="flex items-start gap-6 mb-6">
        <div class="w-56 mdmax:flex-1 mdmax:w-auto">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Group</label>
          <p class="text-neutral-500">{{ adminDetail.group }}</p>
        </div>
        <div class="">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Jenis Kelamin</label>
          <p class="text-neutral-500">{{ adminDetail.gender === 'M' ? 'Laki-laki' : 'Perempuan' }}</p>
        </div>
      </div>
    </div>
    <div class="p-6 flex-1 mdmax:flex-auto mdmax:w-full">
      <p class="font-bold text-lg mb-6">Role & Permission</p>
      <div class="flex items-start gap-6 mb-6">
        <div class="w-56 mdmax:flex-1 mdmax:w-auto">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Role</label>
          <p class="text-neutral-500">{{ adminDetail.role }}</p>
        </div>
        <div class="">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe Role</label>
          <p class="text-neutral-500">{{ adminDetail.role_type }}</p>
        </div>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Permission</label>
        <div class="border px-3 rounded-md">
          <masonry :cols="2" :gutter="30">
            <div v-for="(permission, group) in permissionByGroup" :key="permission.id" class="py-2 block">
              <p class="font-bold text-neutral-500 text-sm">{{ group }}</p>
              <div class="flex gap-6 justify-between items-center py-2 text-sm text-neutral-500" v-for="(item, index) in permission" :key="'item' + index">
                {{ item.id }}
              </div>
            </div>
          </masonry>
        </div>
        <!-- <p class="text-neutral-500" v-for="permission in permissionByGroup" :key="permission.id">{{ permission }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDateTime } from '@/util'
export default {
  filters: {
    formatDateTime
  },
  data() {
    return {
      permissionByGroup: []
    }
  },
  computed: {
    ...mapGetters('admin', ['adminDetail']),
    adminId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('admin', ['getAdminDetail']),
    getAdminInfo() {
      this.getAdminDetail({
        id: this.adminId
      }).then(() => {
        this.permissionByGroup = this.groupBy(this.adminDetail.permissions, 'permission_group_name')
      })
    },
    groupBy(arr, key) {
      const initialValue = {}
      return arr.reduce((acc, cval) => {
        const myAttribute = cval[key]
        acc[myAttribute] = [...(acc[myAttribute] || []), cval]
        return acc
      }, initialValue)
    }
  },
  created() {
    this.getAdminInfo()
  }
}
</script>

<style></style>
